import api from "../api";

class DiagnosisCodeService {
    async getAllDiagnosisCodes() {
        return new Promise((res, reject) => {
            api
                .get("/diagnosisCode")
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async getDiagnosisCodeById(id) {
        return new Promise((res, reject) => {
            api
                .get("/diagnosisCode/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async createDiagnosisCode(obj) {
        return new Promise((res, reject) => {
            api
                .post("/diagnosisCode", obj)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async updateDiagnosisCode(obj) {
        return new Promise((res, reject) => {
            api
                .put("/diagnosisCode", obj)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject();
                });
        });
    }

    async deleteDiagnosisCode(id) {
        return new Promise((res, rej) => {
            return api.delete('/diagnosisCode/' + id).then(data => {
                res();
            }).catch(err => {
                rej();
            });
        });
    }
}

const diagnosisCodeService = new DiagnosisCodeService();

export default diagnosisCodeService;
